import './styles/font-awesome-pro.css'
import ThemeRoot from './ThemeRoot.vue'
import { mountEngine } from '@engine/runtime/mountEngine'
import './styles/fonts.css'
import './styles/tokens.css'
import './styles/reset.css'
import './styles/app.css'
import '@engine/components/image-upload-field.css'
import '@engine/emoticons/emoticons.css'
import './styles/news.css'
import './styles/badges.css'
import './styles/rules-badge.css'
import './styles/admin-slides.css'
import './styles/admin-users.css'
import './styles/admin-servers.css'
import './styles/admin-panel.css'
import './styles/admin-content.css'
import './styles/admin-site-settings.css'
import './styles/shell-chrome.css'

import './styles/admin-runtime-options.css'
import './styles/pages-achievements.css'
mountEngine(ThemeRoot)
